<div class="list-group">

  <a *ngFor="let item of projects" routerLink="/projects/{{item.Id}}" class="list-group-item list-group-item-action">

    <div class="row align-items-center">
      <div class="col-auto pe-2 d-none d-md-block">
        <div class="image-container">
          <img *ngIf="item.Image" [src]="item.Image | imageSize : 80 : 50" />
          <img *ngIf="!item.Image" src="/assets/project-hero-placeholder/hero-placeholder-{{item.Id % 3 + 1}}.jpg" />
        </div>
      </div>

      <div class="col col-shrink">

        <div class="fw-bold oneline mb-0">{{item.Name}}&nbsp;<span class="small fw-normal">{{ texts.genderSuffix[language] }}</span></div>

        <p class="card-text small fw-normal mb-0">

          <!-- <span *ngIf="!item.Locations?.length">Unbekannter Standort</span>
                      <span *ngIf="item.Locations?.length == 1">{{item.Locations[0].City}}</span>
                      <span *ngIf="item.Locations?.length == 2">{{item.Locations[0].City}} + ein weiterer Standort</span>
                      <span *ngIf="item.Locations?.length > 2">{{item.Locations[0].City}} + {{ item.Locations.length - 1 }} weitere Standorte</span> -->

          <span class="text-muted" *ngIf="!item.Candidates?.length"> {{ item | statusName }}</span>
          <span class="text-muted" *ngIf="item.Candidates?.length && item?.Type == 'Full'"> {{ item | statusName }} – {{
            item.Candidates.length }} {{ texts.applications[language] }}</span>
            <span class="text-muted" *ngIf="item.Candidates?.length && item?.Type == 'Longlist'"> {{ item | statusName }} – {{
            item.Candidates.length }} {{ texts.profiles[language] }}</span>
        </p>
      </div>

      <div class="col-auto d-none d-md-block" *ngIf="item.Candidates?.length">
        <sc-avatar-list [users]="item.Candidates" size="xs"></sc-avatar-list>
      </div>

      <!-- <div class="col-auto d-none d-md-block text-muted" *ngIf="item.CandidateCount > 0">
        <span class="badge badge-pill badge-small badge-light text-muted">
          <i class="fa-sharp fa-solid fa-user fa-xs me-1" style="opacity: .35;"></i> {{ item.CandidateCount }}
        </span>
      </div> -->

      <div class="col-auto" *ngIf="item.Status == 'AwaitingOrder'">
        <a class="btn btn-dark btn-sm" [stopClickPropagation] routerLink="/projects/{{item.Id}}"
          [queryParams]="{ view: 'analysis' }">
          {{ texts.analysis[language] }} <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i>
        </a>
      </div>

    </div>
  </a>

</div>
